import { Outlet, NavLink, useNavigate } from 'react-router';
import { LayoutDashboard, Bot, Vote, BarChart3, LogOut, Shield } from 'lucide-react';
import { useAdminLogout } from '@/api';

const ADMIN_NAV = [
  { path: '/admin', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { path: '/admin/characters', label: 'Characters', icon: Bot, end: false },
  { path: '/admin/voting', label: 'Voting', icon: Vote, end: false },
  { path: '/admin/analytics', label: 'Analytics', icon: BarChart3, end: false },
];

export function AdminLayout() {
  const navigate = useNavigate();
  const { logout } = useAdminLogout();

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-black flex">
      {/* Subtle gradient accents matching main app */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[radial-gradient(ellipse_at_top_right,rgba(255,140,66,0.04),transparent_50%)]" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[radial-gradient(ellipse_at_bottom_left,rgba(74,158,255,0.03),transparent_50%)]" />
      </div>

      {/* Sidebar */}
      <aside className="relative z-10 w-64 flex-shrink-0 border-r border-white/[0.08] bg-[rgba(0,0,0,0.95)] backdrop-blur-xl">
        <div className="flex flex-col h-full">
          <div className="p-6 border-b border-white/[0.08]">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center">
                <Shield className="w-5 h-5 text-white" />
              </div>
              <div>
                <span className="font-['Poppins',sans-serif] font-semibold text-white block">Admin</span>
                <span className="text-xs text-[#9595a5]">Control panel</span>
              </div>
            </div>
          </div>

          <nav className="flex-1 p-4 space-y-1">
            {ADMIN_NAV.map(({ path, label, icon: Icon, end }) => (
              <NavLink
                key={path}
                to={path}
                end={end}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? 'bg-white/10 text-white border border-white/[0.12]'
                      : 'text-[#9595a5] hover:bg-white/[0.04] hover:text-white border border-transparent'
                  }`
                }
              >
                <Icon className="w-4 h-4 flex-shrink-0" />
                {label}
              </NavLink>
            ))}
          </nav>

          <div className="p-4 border-t border-white/[0.08]">
            <button
              onClick={handleLogout}
              className="flex items-center gap-3 w-full px-4 py-3 rounded-xl text-sm text-[#9595a5] hover:bg-white/[0.04] hover:text-white transition-colors"
            >
              <LogOut className="w-4 h-4 flex-shrink-0" />
              Log out
            </button>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <main className="relative z-0 flex-1 overflow-auto">
        <div className="p-8 max-w-6xl">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
